<template>
	<div class="admin-authors-table">
		<vx-card class="my-8">
			<div class="perPage">
				<v-select class="selectExample"
						  v-model="select1"
						  :searchable="false"
						  :options="[10,20,50]"/>
			</div>
			<div class="tab-text ">
				<vs-table
					:max-items="select1"
					pagination
					:data="works"
					:currentPage="currentPage"
					@change-page="setCurrentPage"
				>
					<template slot="thead">
						<vs-th v-for="fil in tableFields" :style="'width:' +fil.width" :class="{'justify-center': fil.align && fil.align === 'center'}">
							{{ fil.title }}
						</vs-th>
					</template>

					<template slot-scope="{ data }">
						<vs-tr class="vs-table-filters">
							<template v-for="fil in field">
								<vs-td v-if="fil.field === 'name'">
								  <vs-input class="w-full" v-model="searchName"
											@input="filterTable"></vs-input>
								</vs-td>
								<vs-td v-else-if="fil.field === 'email'">
									<vs-input class="w-full" v-model="searchEmail" @input="filterTable"></vs-input>
								</vs-td>
								<vs-td v-else-if="fil.field === 'phone'">
									<vs-input class="w-full" v-model="searchPhone" @input="filterTable"></vs-input>
								</vs-td>

								<vs-td v-else></vs-td>
							</template>
						</vs-tr>
						<vs-tr
							:key="indextr"
							v-for="(tr, indextr) in data"
							:class="{ 'problem': tr.is_problem }"
						>
							<template v-for="fil in field">
								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-if="fil.field === 'name'">
									<router-link :to="'client/' + tr.id" v-if="role === 'admin'">
										{{ (tr.first_name || tr.last_name) ? `${tr.first_name || ''} ${tr.last_name || ''}` : '---' }}
									</router-link>

									<router-link :to="'clientM/' + tr.id" v-if="role === 'manager'">
										{{ (tr.first_name || tr.last_name) ? `${tr.first_name || ''} ${tr.last_name || ''}` : '---' }}
									</router-link>
								</vs-td>


								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-else-if="fil.field === 'author.username'">
									<router-link v-if="tr[fil.field]" :to="'author/' + deepFind(tr, 'author.id')">
										{{ deepFind(tr, fil.field) }}
									</router-link>
								</vs-td>
								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-else-if="fil.field === 'author'">
									<div class="user-info">
										<div class="user-info__photo ">
											<img :src="tr.photo" alt="">
										</div>
										<router-link class="user-info__block" :to="role === 'admin' ? 'author/' + tr.id : 'authorM/' + tr.id">
											<div class="user-info__name">{{ tr.first_name }}</div>
											<div class="user-info__surname">{{ tr.last_name }}</div>
										</router-link>
									</div>
								</vs-td>

								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-else-if="fil.field === 'active_orders'">
									{{
										tr.orders_active_count
									}}
								</vs-td>

								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-else-if="fil.field === 'actions'">
									<div  class="flex justify-center">
										<vs-custom-button v-if="role === 'admin'"
											size="small"
											color="#626262"
											type="flat"
											icon-pack="feather"
											icon="edit"
											@click="$router.push('/client/'+tr.id+'/edit')"
										>
											<feather-icon icon="EditIcon"></feather-icon>
										</vs-custom-button>

										<vs-custom-button
											size="small"
											color="#626262"
											type="flat"
											icon-pack="feather"
                      @click='editModel = tr;
                      $vs.dialog({
                        color: "danger",
                        title: $t(`confirmDeletion`),
                        acceptText: $t(`delete`),
                        cancelText: $t(`cancel`),
                        text: $t(`confirmDeletion`) + " \"" + tr.first_name + " " + tr.last_name + "\"",
                        accept: removePackage,
                      });
                    '

                      icon="edit"
										>
											<feather-icon icon="Trash2Icon"></feather-icon>
										</vs-custom-button>
									</div>
								</vs-td>
								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-else-if="tr[fil.field]">
									{{tr[fil.field]}}
								</vs-td>
								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-else>
									...
								</vs-td>
							</template>

						</vs-tr>
					</template>
				</vs-table>
			</div>
		</vx-card>
		<vs-prompt
			@cancel="date = ''"
			@accept="addAuthor"
			:buttons-hidden="true"
			:active.sync="activePrompt"
			:title="$t('registrationLinkCreation')"
			:acceptText="$t('create')"
			color="success"
			:cancelText="$t('cancel')"
			class="add-author-prompt"
		>
			<div class="flex items-end">
				<vs-input
					:label="$t('linkToRegistrationForm')"
					ref="mylink"
					class="w-full mr-3"
					placeholder="Placeholder"
					v-model="linkAuthor"
					color="success"
				/>
				<vs-button
					size="small"
					icon-pack="feather"
					@click="copyURL"
					icon="edit"
				>
					<feather-icon icon="CopyIcon"></feather-icon>
				</vs-button>
			</div>
			<div class="add-author-prompt__controls">
				<vs-button
					@click="generateLink"
					color="success"
					class="add-author-prompt__refresh"
				>{{ $t('generate') }}</vs-button>

				<vs-custom-button
					@click="activePrompt = false"
					type="flat"
					color="dark"
					class="add-author-prompt__close"
				>{{ $t('close') }}</vs-custom-button>
			</div>
		</vs-prompt>
	</div>
</template>

<script>
import vSelect from 'vue-select'
import debounce from 'debounce'
import notifier from "@/mixins/notifier";

export default {
	name: "PackageList",
	mixins: [notifier],
	components: {
		'v-select': vSelect,
	},
	data() {
		return {
			searchName: '',
			searchEmail: '',
			searchStatus: null,
			searchUsername: '',
			searchPhone: '',
			searchGender: null,
			searchCountry: null,
			searchLevels: null,

			select1: 10,
			nameRu: '',
			nameDe: '',
			price: '',
			juniorIs: false,

			countries: [],
			genders: [],
			activePrompt: false,
			activePromptEdit: false,
			popupActiv: false,
			subjects: [],
			levels: [],
			works: [],
			editModel: {},
			linkAuthor: '',
			options: '',
			currentPage: 1
		};
	},

	computed: {
		role() {
			return this.$store.state.auth.role
		},
		tableFields() {
			return this.role === 'admin' ? this.field : this.managersField
		},
	},

	methods: {
	  getClientName(firstName, lastName) {
		const fullName = [firstName, lastName].join(" ");
		return fullName !== " " ? fullName : "---";
	  },
		setCurrentPage(data) {
			this.currentPage = data
		},
		copyURL() {
			var Url = this.$refs.mylink
			Url.$el.querySelector('.vs-inputx').select();
			document.execCommand("copy");
		},
		async generateLink(){
			let uid = (await this.$http.get('/admin/author/get-registration-link')).data.data.uid;
			this.linkAuthor = location.origin + '/registrationAuthor?id='+uid;
			this.activePrompt = true;
		},
		addAuthor(){

		},

		filterTable:  debounce(function (e) {
			this.options = '?'
			if(this.searchName.length > 0) this.options += 'filter[name]='+this.searchName+'&'
			if(this.searchUsername.length > 0) this.options += 'filter[username]='+this.searchUsername+'&'
			if(this.searchEmail.length > 0) this.options += 'filter[email]='+this.searchEmail+'&'
			if(this.searchPhone.length > 0) this.options += 'filter[phone]='+this.searchPhone
			this.currentPage = 1
			this.getWorks();
		}, 500),
    async removePackage(){

      try {
        await this.$http.post(`/${this.role}/client/update/${this.editModel.id}`, {
          reset_package: 1,
        });
        this.notifySuccess(this.$t('deletedSuccessfully'));
        this.editModel = {};
        this.getWorks();

      } catch (e) {
        this.notifyError(e.message);
      }
    },
    // async removePackage(tr) {
    //   let response;
    //
    //   try {
    //     response = await this.$http.post(`/${this.role}/client/update/${tr.id}`, {
    //       reset_package: 1,
    //     });
    //   } catch (e) {
    //     // если тут реально ошибка сети / 4xx / 5xx
    //     this.$vs.notify({
    //       color: 'danger',
    //       title: this.$t('error'),
    //     });
    //     return;
    //   }
    //
    //   // Всё, что ниже — выполняется ВСЕГДА, если запрос дошёл до сервера
    //   // и он вернул ответ (даже если axios внутри странно себя ведёт)
    //
    //   this.items = this.items.filter(item => item.id !== tr.id);
    //
    //   this.$vs.notify({
    //     color: 'success',
    //     title: this.$t('success'),
    //   });
    // },



    async editTask(id) {
			try {
				let validator = await this.$validator.validateAll();
				if(!validator) return this.activePromptEdit = true;
				let formData = {
					"name_ru": this.editModel.name_ru,
					"name_de": this.editModel.name_de,
					"price": this.editModel.price,
					"is_enabled_for_junior": this.editModel.is_enabled_for_junior
				}
				await this.$http.post("/admin/author/update/"+this.editModel.id,formData);

				this.notifySuccess(this.$t('changedSuccessfully'));
				this.editModel = {};
				this.activePromptEdit = false;
				this.getWorks();

			} catch (e) {
				this.notifyError(e.message);
			}
		},
		async createTask(id) {
			try {
				let validator = await this.$validator.validateAll();
				if(!validator) return this.activePrompt = true;
				let formData = {
					"name_ru": this.nameRu,
					"name_de": this.nameDe,
					"price": this.price,
					"is_enabled_for_junior": this.juniorIs
				}

				await this.$http.post("/admin/author/create",formData);

				this.notifySuccess(this.$t('addedSuccessfully'));
				this.nameRu = "";
				this.nameDe = "";
				this.price = "";
				this.juniorIs = false;
				this.popupActiv = false;
				this.getWorks();

			} catch (e) {
				this.$vs.notify({
					title: "Error",
					text: e.message,
					iconPack: "feather",
					icon: "icon-alert-circle",
					color: "danger",
				});
			}
		},
		deepFind(obj, path) {
			if (!path) return "";
			let paths = path.split("."),
				current = obj,
				i;

			for (i = 0; i < paths.length; ++i) {
				if (current[paths[i]] === undefined) {
					return undefined;
				} else {
					current = current[paths[i]];
				}
			}
			return current;
		},
		async getWorks() {

			try {
				let url = this.options ? `/${this.role}/client/by-work-type` + this.options : `/${this.role}/client/by-work-type`;
				const res = (await this.$http.get(url)).data.data;

				this.works = res !== null ? res : [];
			} catch (e) {
				this.$vs.notify({
					title: "Error",
					text: e.message,
					iconPack: "feather",
					icon: "icon-alert-circle",
					color: "danger",
				});
			}
		},
	},
	created() {
    this.field = [
      {
        field: "name",
        title: this.$t('name'),
        align: 'center',
      },
      {
        field: "email",
        title: "E-mail",
        align: 'center',
      },
      {
        field: "phone",
        title: this.$t('phone'),
        align: 'center',
      },
      {
        field: "tickets_count",
        title: this.$t('totalWorks'),
        align: 'center',
      },
      {
        field: "tickets_active_count",
        title: this.$t('activatedTickets'),
        align: 'center',
      },
      {
        field: "package_expiry_date",
        title: this.$t('packageExpiry'),
        align: 'center',
      },
      {
        field: "package",
        title: this.$t('workTypeName'),
        align: 'center',
      },
      {
        field: "actions",
        title: this.$t('actions'),
        align: 'center',
        width: '11.25%'
      },
    ];

    this.managersField = [
      {
        field: "name",
        title: this.$t('name'),
        align: 'center',
      },
      {
        field: "email",
        title: "E-mail",
        align: 'center',
      },
      {
        field: "phone",
        title: this.$t('phone'),
        align: 'center',
      },
      {
        field: "tickets_count",
        title: this.$t('totalWorks'),
        align: 'center',
      },
      {
        field: "tickets_active_count",
        title: this.$t('activatedTickets'),
        align: 'center',
      },
      {
        field: "package_expiry_date",
        title: this.$t('packageExpiry'),
        align: 'center',
      },
      {
        field: "package",
        title: this.$t('workTypeName'),
        align: 'center',
      },

      {
        field: "actions",
        title: this.$t('actions'),
        align: 'center',
        width: '11.25%'
      },
		];
	},
	async mounted() {

    this.getWorks();

	},
};
</script>

<style lang="scss">
@import "../../assets/scss/vuexy/variables";
@import "../../assets/scss/vuexy/functions";

.vs__dropdown-menu {
	min-width: fit-content;
}

.admin-authors-table {
	.buttons {
		justify-content: flex-end;
	}

	.button-task {
		border-radius: 22px;
		padding: 0.25rem 0.7rem !important;
	}

	.vs__selected-options {
		flex-wrap: nowrap;
	}

	.user-info {
		display: flex;
		justify-content: flex-start;
		align-items: center;

		&__photo{
			display: flex;
			justify-content: center;
			align-items: center;
			flex: 30px 0 0;
			width: 30px;
			height: 30px;
			overflow: hidden;
			border-radius: 100%;
			margin-right: 10px;

			img {
				width: 100%;
				height: 100%;
			}
		}

		&__block {
			display: flex;
			justify-content: center;
		}

		&__surname {
			margin-left: 7px;
		}
	}

	.fade-enter-active,
	.fade-leave-active {
		transition: opacity 0.5s;
	}
	.vs-con-table .vs-con-tbody,.vs-table--content{
		overflow: visible;
	}
	.perPage{
		width: 65px;
		flex: 0 0 auto;

		.vs__dropdown-toggle{
			border-radius: 100px;
			padding: 0;
		}
		.vs__clear{
			display: none;
		}
		.vs__selected-options {
			padding-left: 13px;
			.vs__selected {
				padding: 0;
				flex: 0 0 auto;
				padding: 0;
			}
		}

		.vs__search {
			padding: 0;
		}

		.v-select__selection {
			width: 100%;
			justify-content: center;
		}
	}
	.inputInTable {
		border: 0;
		resize: none;
	}
	.fade-enter, .fade-leave-to {
		opacity: 0;
	}
	.buttons {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		@media screen and (max-width: 375px) {
			button {
				margin: 5px 0;
			}
		}
	}
	.justify-center .vs-table-text{
		justify-content: center;
	}
	.vs-checkbox-default{
		flex-shrink: 0;
	}
	.vs-tabs--content {
		padding: 0;
		margin-top: 10px;
	}

	.vs-con-table .vs-con-tbody {
		border: 0;
		background-color: transparent;
	}

	.vs-table {
		margin-top: 10px;

		tr {
			border-top: 1px solid #cfcfcf;

			&:last-child {
				border-bottom: 1px solid #cfcfcf;
			}
		}
	}
	.con-vs-tabs .con-slot-tabs{
		overflow: visible;
	}
	.task {
		background-color: #3ac47d;
		border-radius: 10px;
		padding: 4px 10px;
		color: white;
	}
	.counter {
		display: inline-block;
		padding: 5px;
		border-radius: 100%;
		font-weight: 600;
		width: 20px;
		height: 20px;
		font-size: 0.7rem;
		border: 1px solid #cfcfcf;
		display: flex;
		align-items: center;
		justify-content: center;
		line-height: 1;

		&.warn {
			background-color: #f0ad4e;
			color: white;
			border-color: #f0ad4e;
		}
	}

	.filter {
		border-bottom: 1px solid #e5e5e5;
		padding-bottom: 1rem;
		padding-top: 0.5rem;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		.date {
			display: flex;
			align-items: center;
		}
		.vx-input-group .vx-input-group-default .vs-input {
			width: 150px;
		}
		.vx-input-group {
			margin-right: 20px;
		}
		.search .vs-icon {
			height: 100%;
			width: 35px;
			background: $primary;
			position: absolute;
			top: 0;
			right: 0;
			color: white !important;
			display: flex;
			align-items: center;
			justify-content: center;
			border-top-right-radius: 4px;
			border-bottom-right-radius: 4px;
			font-size: 22px;
		}
		.search .vs-con-input-label {
			width: 270px;
		}
	}
}

.con-exemple-prompt {
	.append-text {
		height: 2.7rem;
	}
	.vs-button {
		border-left: 0;
	}
	.vx-input-group-append {
		align-items: flex-end;
	}
	.vs-input {
		width: 100%;
		textarea {
			resize: none;
		}
	}
}

.viewTask {
	.vs-popup--title h3 {
		color: $primary;
	}
	.vs-popup--content {
		padding: 0;
	}
	table {
		width: 100%;
		td {
			padding-bottom: 4px;
		}
	}
	.body {
		padding: 1rem;
		table {
			margin-left: -2px;
		}
		p {
			padding-top: 10px;
			font-size: rem(14px);
		}
	}
	.footer {
		border-top: 1px solid rgba(0, 0, 0, 0.05);
		padding: 0.5rem 1rem;
		display: flex;
		justify-content: flex-end;
		button {
			margin-left: 10px;
		}
	}
}

.add-author-prompt {
	&__controls {
		display: flex;
		flex-wrap: wrap;
		justify-content: flex-end;
		margin-top: 30px;
		padding-top: 14px;
		border-top: rgba(199, 199, 199, 0.53) 1px solid;
	}

	&__close {
		color: #727272 !important;
	}

}
tr {
	&.problem {
		background: #ea545481;
	}
}
</style>
